// src/PrivateRoute.jsx
import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'

const PrivateRoute = ({ children }) => {
  const [checking, setChecking] = React.useState(true)
  const [isAuthenticated, setIsAuthenticated] = React.useState(false)
  const location = useLocation()

  React.useEffect(() => {
    const token = localStorage.getItem('token')
    if (token) {
      setIsAuthenticated(true)
    }
    setChecking(false)
  }, [])

  if (checking) {
    return <div>Chargement...</div>
  }

  if (!isAuthenticated) {
    // ✅ On enregistre la page demandée avant redirection
    sessionStorage.setItem('intended_path', location.pathname)
    return <Navigate to="/login" replace />
  }

  return children
}

export default PrivateRoute
